import { render, staticRenderFns } from "./RecruitmentInfo.vue?vue&type=template&id=8cfd0c7e&scoped=true"
import script from "./RecruitmentInfo.vue?vue&type=script&lang=js"
export * from "./RecruitmentInfo.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentInfo.vue?vue&type=style&index=0&id=8cfd0c7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfd0c7e",
  null
  
)

export default component.exports